<template>
  <b-form-group
    :disabled="disabled"
  >
    <div>
      <b-input-group
        class="input-group-merge search-component"
        size="sm"
      >
        <b-input-group-prepend
          is-text
          :class="disabled ? 'disabled-prepend' : ''">
          <GjIcon name="Search" />
        </b-input-group-prepend>
        <b-form-input
          v-model="search"
          v-debounce="onSearchInputChange"
          :placeholder="placeholder"
          type="text"
          class="d-inline-block"
          :class="disabled ? 'disabled-prepend' : ''"
          size="sm"
        />
        <b-input-group-append
          v-if="search"
          is-text
          @click="clearSearchInput"
        >
          <GjIcon name="Close" />
        </b-input-group-append>
      </b-input-group>

    </div>
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { ref } from '@vue/composition-api'
import vueDebounce from 'vue-debounce'
import Vue from 'vue'

Vue.use(vueDebounce)
Vue.use(vueDebounce, {
  listenTo: 'input',
  defaultTime: '700ms',
})

export default {
  components: {
    BFormGroup,
    BFormInput,
    GjIcon,
  },
  props: {
    placeholder: {
      type: [String],
    },
    disabled: {
      type: Boolean,
    },
  },
  setup(_, context) {
    const search = ref('')
    const onSearchInputChange = () => {
      context.emit('onInputSearch', search.value)
    }

    const clearSearchInput = () => {
      search.value = ''
      onSearchInputChange()
    }

    return {
      onSearchInputChange,
      search,
      clearSearchInput,
    }
  },
}
</script>
<style lang="scss" scoped>
.search-component {
  width: 250px;
  input {
    max-width: 200px;
    max-height: 34px;
  }
}
.disabled-prepend{
  background-color: transparent;
  &.form-control {
    border-color: #e0e5eb;
  }
  & > .input-group-text {
    background-color: transparent;
    border-color: #e0e5eb;
  }
}
</style>
